import Vue from 'vue'
import { Config } from '@/config.js'
const md5 = require('md5')
const crypto = require('crypto')
const pako = require('pako')

// reverseString
function rs(str) {
  return str === '' ? '' : rs(str.substr(1)) + str.charAt(0)
}

// eslint-disable-next-line encode
String.prototype.hed = function() {
  var hex, i

  var result = ''
  for (i = 0; i < this.length; i++) {
    hex = this.charCodeAt(i).toString(16)
    result += ('000' + hex).slice(-4)
  }

  return rs(result)
}

// eslint-disable-next-line decode
String.prototype.hdd = function() {
  var j
  let a = rs(this)
  var hexes = a.match(/.{1,4}/g) || []
  var back = ''
  for (j = 0; j < hexes.length; j++) {
    back += String.fromCharCode(parseInt(hexes[j], 16))
  }

  return back
}

let sel = function sel(s) {
  // *enc*+ eval c600160067005600
  return window['c600160067005600'.hdd()](s)
}

let decrypt = function decrypt(text) {
  // *enc*+ _MD 4400d400f500
  // *enc*+ organization e600f600960047001600a7009600e600160076002700f600

  const keyt = Config['e600f600960047001600a7009600e600160076002700f600'.hdd()] + '4400d400f500'.hdd()

  // *enc*+ SPX_MD 4400d400f500850005003500
  const ivt = '4400d400f500850005003500'.hdd()

  let key = md5(keyt)
  let iv = md5(ivt)

  iv = iv.toString('hex').slice(0, 16)

  // let decipher = crypto.createDecipheriv(aescbc(), Buffer.from(key), iv)
  // *enc*+ createDecipheriv 6700960027005600860007009600360056004400560047001600560027003600
  let decipher = crypto['6700960027005600860007009600360056004400560047001600560027003600'.hdd()](aescbc(), Buffer.from(key), iv)

  let decrypted = decipher.update(text, 'hex')
  decrypted = Buffer.concat([decrypted, decipher.final()])
  return decrypted.toString()
}

let glo = function glo(name) {
  let encData = localStorage.getItem(name)
  if (encData == null) {
    return null
  }
  let decData = decrypt(encData)
  return JSON.parse(decData)
}
// encrpt with key
let ewk = function ewk(text, key, iv) {
  key = md5(key)
  iv = md5(iv)

  iv = iv.toString('hex').slice(0, 16)

  let cipher = crypto.createCipheriv(aescbc(), key, iv)
  const encrypted = Buffer.concat([cipher.update(text, 'utf8'), cipher.final()])

  // *enc*+ base64 430063005600370016002600
  return encrypted.toString('430063005600370016002600'.hdd())
}

// decryptWithKey
let dwk = function dwk(text, keyt, ivt) {
  let key = md5(keyt)
  let iv = md5(ivt)

  iv = iv.toString('hex').slice(0, 16)

  // let decipher = crypto.createDecipheriv(aescbc(), Buffer.from(key), iv)
  // *enc*+ createDecipheriv 6700960027005600860007009600360056004400560047001600560027003600
  let decipher = crypto['6700960027005600860007009600360056004400560047001600560027003600'.hdd()](aescbc(), Buffer.from(key), iv)
  // *enc*+ base64 430063005600370016002600
  let decrypted = decipher.update(text, '430063005600370016002600'.hdd())
  decrypted = Buffer.concat([decrypted, decipher.final()])
  return decrypted.toString()
}

let dm = function dm(message) {
  // *enc*+  From d600f60027006400
  // *enc*+ To f6004500
  if (message.mv !== 2) {
    var key = message['d600f60027006400'.hdd()] + message['f6004500'.hdd()]
    var iv = key
      .split('')
      .reverse()
      .join('')

    if (message.Body && message.Body !== '') {
      try {
        let decryptedBody = dwk(message.Body, key, iv)
        message.Body = decryptedBody
      } catch (err) {
        console.log(err)
      }
    }

    if (message.MediaURLs) {
      var MediaURLs = []
      message.MediaURLs.forEach(mu => {
        try {
          let decryptedMediaURL = dwk(mu, key, iv)
          MediaURLs.push(decryptedMediaURL)
        } catch (err) {
          MediaURLs.push(mu)
        }
      })
      message.MediaURLs = MediaURLs
    }
  } else {
    var messageID = message.MessageID
    var last1Char = messageID.charAt(messageID.length - 1)
    var last2Char = messageID.charAt(messageID.length - 2)

    var last1 = last1Char.charCodeAt(0) % 5
    var last2 = last2Char.charCodeAt(0) % 5
    var parts = messageID.split('-')
    var key = message['d600f60027006400'.hdd()] + parts[last1] + parts[last2] + 'da81b159-a8d1-4f56-90b7-914d1a561bb0' + message['f6004500'.hdd()]
    var iv = key
      .split('')
      .reverse()
      .join('')

    if (message.Body && message.Body !== '') {
      try {
        let decryptedBody = dwk(message.Body, key, iv)
        message.Body = decryptedBody
      } catch (err) {}
    }

    if (message.MediaURLs) {
      var MediaURLs = []
      message.MediaURLs.forEach(mu => {
        try {
          let decryptedMediaURL = dwk(mu, key, iv)
          MediaURLs.push(decryptedMediaURL)
        } catch (err) {
          MediaURLs.push(mu)
        }
      })
      message.MediaURLs = MediaURLs
    }
  }
}

let encrypt = function encrypt(text) {
  // *enc*+ _MD 4400d400f500
  // *enc*+ organization e600f600960047001600a7009600e600160076002700f600
  const keyt = Config['e600f600960047001600a7009600e600160076002700f600'.hdd()] + '4400d400f500'.hdd()
  // *enc*+ SPX_MD 4400d400f500850005003500
  const ivt = '4400d400f500850005003500'.hdd()
  let key = md5(keyt)
  let iv = md5(ivt)

  iv = iv.toString('hex').slice(0, 16)

  let cipher = crypto.createCipheriv(aescbc(), Buffer.from(key), iv)
  let encrypted = cipher.update(text)
  encrypted = Buffer.concat([encrypted, cipher.final()])
  return encrypted.toString('hex')
}

let slo = function slo(name, data) {
  let encData = encrypt(JSON.stringify(data))
  localStorage.setItem(name, encData)
}

let em = function em(message) {
  // *enc*+ From d600f60027006400
  // *enc*+ To f6004500
  if (message.mv !== 2) {
    var key = message['d600f60027006400'.hdd()] + message['f6004500'.hdd()]
    var iv = key
      .split('')
      .reverse()
      .join('')
    let encBody = ewk(message.Body, key, iv)
    message.Body = encBody

    if (message.MediaURLs && message.MediaURLs.length > 0) {
      var MediaURLs = []
      message.MediaURLs.forEach(mu => {
        let encMediaURL = ewk(mu, key, iv)
        MediaURLs.push(encMediaURL)
      })
      message.MediaURLs = MediaURLs
    }
  } else {
    var messageID = message.MessageID
    var last1Char = messageID.charAt(messageID.length - 1)
    var last2Char = messageID.charAt(messageID.length - 2)

    var last1 = last1Char.charCodeAt(0) % 5
    var last2 = last2Char.charCodeAt(0) % 5
    var parts = messageID.split('-')

    var key = message['d600f60027006400'.hdd()] + parts[last1] + parts[last2] + 'da81b159-a8d1-4f56-90b7-914d1a561bb0' + message['f6004500'.hdd()]
    // var key = message['d600f60027006400'.hdd()] + message['f6004500'.hdd()]
    var iv = key
      .split('')
      .reverse()
      .join('')
    if (message.Body !== '') {
      let encBody = ewk(message.Body, key, iv)
      message.Body = encBody
    }

    if (message.MediaURLs && message.MediaURLs.length > 0) {
      var MediaURLs = []
      message.MediaURLs.forEach(mu => {
        let encMediaURL = ewk(mu, key, iv)
        MediaURLs.push(encMediaURL)
      })
      message.MediaURLs = MediaURLs
    }
  }
}

let rlo = function rlo(name) {
  localStorage.removeItem(name)
}

let aescbc = function aescbc() {
  /*
    let fuStr = `
    let d1 = '370056001600'
    let d2 = 'd200'
    let d3 = '630053002300'
    let d4 = '360026003600'
    d4 + d2 + d3 + d2 + d1
    `

    let fuStrHex = fuStr.hed()
    console.log(fuStrHex);

    let aor = '02000200a000130046000200b2000200230046000200b2000200330046000200b2000200230046000200b20002004300460002000200a000720003000300630033000300030063002300030003006300330072000200d300020043004600020047005600c60002000200a000720003000300330023000300030033005300030003003300630072000200d300020033004600020047005600c60002000200a0007200030003002300460072000200d300020023004600020047005600c60002000200a000720003000300630013000300030063005300030003007300330072000200d300020013004600020047005600c60002000200a000'

    var output = pako.gzip(aor,{ to: 'string' });
    let bs64or = window.btoa(output);
    console.log(bs64or);
  */

  let bs64 = 'H4sIAAAAAAAAA5VQQQ7AIAj7UqUq73Hb/98wjZoYdIseiLRgSwoBkCvlxxHwseKr8bLguLnnB657aOlZK7JqjVg4z7X9fzjregVC7u8fHxrdgoPBceHDQ5+egdWRQ51yizM5jPfqRy5uw+cFct+DTfABAAA='

  // console.log('ungzip'.hed()); //0075006e0067007a00690070

  // *enc*+ ungzip 07009600a7007600e6005700
  let a = pako['07009600a7007600e6005700'.hdd()](window.atob(bs64), {
    to: 'string'
  })
  // returns aescbc string
  return sel(a.hdd()).hdd()
}
Vue.prototype.dwk = dwk
Vue.prototype.ewk = ewk
Vue.prototype.em = em
Vue.prototype.dm = dm
Vue.prototype.slo = slo
Vue.prototype.glo = glo
Vue.prototype.rlo = rlo
